import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { withRouter } from 'react-router-dom';
import HeaderComponent from './HeaderComponent';
import SidebarComponent from './SidebarComponent';
import { useDispatch } from 'react-redux';
import { loadCurrentUser } from '../../redux/asyncActions/currentUser';
const { Content } = Layout;

const MOBILE_QUERY = '(max-width: 767px)';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    // Safari < 14 supports only addListener
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isMobile;
};

function BasicLayout(props) {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(isMobile);
  const dispatch = useDispatch();
  const { pathname } = props.location;

  const handleCollapseMenu = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    dispatch(loadCurrentUser());
  }, [dispatch]);

  // On mobile the menu overlays the content, so hide it after navigation
  useEffect(() => {
    if (isMobile) setCollapsed(true);
  }, [pathname, isMobile]);

  return (
    <Layout>
      <HeaderComponent
        collapsed={collapsed}
        handleCollapseMenu={handleCollapseMenu}
      />
      <Layout className="main-layout">
        <SidebarComponent
          route={props.location}
          collapsed={collapsed}
          isMobile={isMobile}
        />
        {isMobile && !collapsed && (
          <div
            className="sidebar-backdrop"
            onClick={() => setCollapsed(true)}
          />
        )}
        <Layout className="main-layout__content">
          <Content
            style={{
              background: '#fff',
              padding: isMobile ? 12 : 24,
              margin: 0,
              // minHeight: "250%",
            }}
          >
            {props.children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default withRouter(BasicLayout);
